<!--
  The saved mix designs.

  A list and a "New mix design" button, nothing else: the sheet itself is the
  form on the next screen.
-->
<script lang="ts">
  import { linkHandler, navigate, routePath } from '../lib/router';
  import { loadMixDesigns, mixDesigns, mixDesignsLoading } from '../lib/store';

  $effect(() => {
    void loadMixDesigns();
  });

  /** '2026-08-21T09:14:02.101Z' -> '2026-08-21'. */
  function day(timestamp: string): string {
    return timestamp.slice(0, 10);
  }
</script>

<div class="card">
  <div class="card__body">
    <h1 class="card__title">Mix designs</h1>
    <button
      class="btn btn--primary btn--block"
      type="button"
      onclick={() => navigate(routePath.newMixDesign())}
    >
      New mix design
    </button>
  </div>
</div>

{#if $mixDesignsLoading && $mixDesigns.length === 0}
  <p class="meta center"><span class="spinner" aria-hidden="true"></span> Loading…</p>
{:else if $mixDesigns.length === 0}
  <div class="card">
    <div class="card__body">
      <p class="meta">
        No mix designs saved yet. The first one starts from the standard SCI sheet.
      </p>
    </div>
  </div>
{:else}
  <div class="card">
    <div class="card__body">
      <ul class="mixlist">
        {#each $mixDesigns as design (design.id)}
          <li>
            <a href={routePath.mixDesign(design.id)} onclick={linkHandler}>
              <strong>{design.mix_code || 'Untitled mix'}</strong>
              <span class="meta">{design.project_name || 'No project name'}</span>
              {#if design.subject}<span class="meta">{design.subject}</span>{/if}
              <span class="meta">
                {design.material_count} material{design.material_count === 1 ? '' : 's'}
                · updated {day(design.updated_at)}
              </span>
            </a>
          </li>
        {/each}
      </ul>
    </div>
  </div>
{/if}

<style>
  .mixlist {
    list-style: none;
    margin: 0;
    padding: 0;
  }

  .mixlist li + li {
    border-top: 1px solid var(--line-soft);
  }

  .mixlist a {
    display: flex;
    flex-direction: column;
    gap: 0.15rem;
    padding: 0.85rem 0;
    color: inherit;
    text-decoration: none;
    /* Tapped with gloves on, same as the field screens. */
    min-height: var(--tap);
  }

  .mixlist a:hover strong {
    text-decoration: underline;
  }
</style>
